import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';
import { APP_DOMAIN } from './../../env';

const Unauthorized = () => {
    const navigate = useNavigate();
    const [particles, setParticles] = useState<{ top: string; left: string; size: string; duration: string }[]>([]);

    const logout = useCallback(() => {
        document.cookie = 'accessToken=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        window.location.href = `https://app.${APP_DOMAIN}.com`;
    }, []);

    useEffect(() => {
        const generateParticles = () => {
            const totalParticles = 30;
            const newParticles = Array.from({ length: totalParticles }, () => ({
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                size: `${Math.random() * 5 + 1}px`,
                duration: `${Math.random() * 4 + 2}s`,
            }));
            setParticles(newParticles);
        };
        generateParticles();
    }, []);

    return (
        <div className="flex items-center justify-center bg-gradient-to-br from-white to-blue-100 text-blue-900 p-8 overflow-hidden w-full">
            <div className="rounded-xl p-10 w-full max-w-xl text-center relative">
                <style>{`
                    @keyframes floating {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(-15px); }
                    }
                    .animate-floating {
                        animation: floating 3s ease-in-out infinite;
                    }
                    @keyframes bounce {
                        0%, 100% { transform: translateY(0); }
                        50% { transform: translateY(-10px); }
                    }
                    .animate-bounce {
                        animation: bounce 1s infinite;
                    }
                    @keyframes particle-animation {
                        0% { transform: translateY(0); opacity: 1; }
                        100% { transform: translateY(-200px); opacity: 0; }
                    }
                    .particle {
                        position: absolute;
                        background: rgba(108, 95, 252, 0.7);
                        border-radius: 50%;
                        animation: particle-animation linear infinite;
                    }
                `}</style>

                <div className="icon-container flex justify-center items-center mb-8 relative animate-floating">

                    <svg className="w-32 h-32 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C9.24 2 7 4.24 7 7v4H6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V12c0-.55-.45-1-1-1h-1V7c0-2.76-2.24-5-5-5zm-1 4h2c.55 0 1 .45 1 1v3h-4V7c0-.55.45-1 1-1z"/>

                    </svg>
                    <div className="absolute top-16 left-20 animate-bounce">
                        <svg className="w-8 h-8 text-blue-200" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M6.7 2.3L1.6 7.4c-.4.4-.4 1 0 1.4l4.2 4.2c.4.4 1 .4 1.4 0l5.1-5.1c.4-.4.4-1 0-1.4L8.1 2.3c-.4-.4-1-.4-1.4 0zM13.8 9.4L12 10.6 7.4 6l1.2-1.8c.4-.6 1-.8 1.6-.5l2.8 1.4c.6.3.8 1 .5 1.6L13.8 9.4z"/>
                        </svg>
                    </div>
                </div>

                <h2 className="text-5xl font-bold mb-4 text-blue-900">403 Unauthorized</h2>
                <p className="text-lg text-blue-800 text-center mb-6">
                    Oops! You don&apos;t have permission to access this page. Please check your credentials or contact support.
                </p>

                <div className="flex gap-4 justify-center">
                    <button
                        onClick={() => navigate('/')}
                        className="px-8 py-3 font-medium text-white bg-primary rounded-full shadow-md hover:shadow-lg hover:bg-primaryLight focus:outline-none focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50 transform transition-transform duration-300 hover:scale-110"
                    >
                        Return Home
                    </button>
                    <button
                        onClick={logout}
                        className="px-8 py-3 font-medium bg-transparent border border-red-500 text-red-500 rounded-full shadow-md hover:shadow-lg hover:bg-danger hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50 transform transition-transform duration-300 hover:scale-110"
                    >
                        Logout
                    </button>
                </div>

                {particles.map((particle, index) => (
                    <div
                        key={index}
                        className="particle"
                        style={{
                            top: particle.top,
                            left: particle.left,
                            width: particle.size,
                            height: particle.size,
                            animationDuration: particle.duration,
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default Unauthorized;
